import styled from '@emotion/styled';

export const AuthContentContainer = styled.div`
  width: 404px;
  color: var(--FFFFFF-auth-pages-form);
  display: flex;
  flex-direction: column;
  align-items: center;
`;
